import { supabase } from '@/lib/supabase/supabaseClient';
import { useInviteUserToOrganizationProps } from '.';

export const inviteUserToOrganization = async ({
  orgId,
  email,
}: useInviteUserToOrganizationProps) =>
  await supabase.functions.invoke(`rest/org/${orgId}/invite`, {
    body: JSON.stringify({
      invitedUserEmail: email,
    }),
    headers: {
        origin: location.origin,
        dev: 'true',
    },
    method: 'POST',
  });
